/**
 * Pluralize helper — één centrale utility voor NL-meervouden.
 *
 * Sprint P0.11 · Communicatie Sprint (20 Feb 2026).  Elke lijst / KPI / label
 * in het CRM zou hier langs moeten:
 *
 *     pluralize(count, "factuur", "facturen")           → "2 facturen"
 *     pluralize(0, "klant", "klanten")                   → "0 klanten"
 *     pluralize(1, "bijlage", "bijlagen")                → "1 bijlage"
 *     pluralize(3, "reminder", "reminders", {zero:"geen"}) → "3 reminders"
 *     pluralize(0, "reminder", "reminders", {zero:"geen"}) → "geen reminders"
 *
 * Options:
 *   zero        override tekst voor 0 (bv. "geen")
 *   hideNumber  gebruikt de zero-tekst zonder "0 " prefix
 *   locale      standaard "nl-NL" — voor number-formatting
 */

export function pluralize(count, singular, plural, opts = {}) {
  const n = Number(count) || 0;
  if (n === 0 && opts.zero) {
    return opts.hideNumber ? opts.zero : `${opts.zero} ${plural}`;
  }
  const word = n === 1 ? singular : plural;
  const formatted = new Intl.NumberFormat(opts.locale || "nl-NL").format(n);
  return `${formatted} ${word}`;
}

/**
 * Kort suffix — geeft alleen het juiste woord terug, geen aantal.
 *
 *     pluralWord(2, "factuur", "facturen") → "facturen"
 */
export function pluralWord(count, singular, plural) {
  return (Number(count) || 0) === 1 ? singular : plural;
}

/**
 * Common NL-terms — bundel om typos te voorkomen.
 *
 *     nlTerm("invoice", 2)   → "2 facturen"
 *     nlTerm("attachment", 1) → "1 bijlage"
 */
const NL_TERMS = {
  invoice:     ["factuur", "facturen"],
  quote:       ["offerte", "offertes"],
  customer:    ["klant", "klanten"],
  reminder:    ["reminder", "reminders"],
  attachment:  ["bijlage", "bijlagen"],
  payment:     ["betaling", "betalingen"],
  session:     ["sessie", "sessies"],
  order:       ["bestelling", "bestellingen"],
  shipment:    ["zending", "zendingen"],
  arrangement: ["regeling", "regelingen"],
  installment: ["termijn", "termijnen"],
  event:       ["event", "events"],
  message:     ["bericht", "berichten"],
  contact:     ["contact", "contacten"],
  day:         ["dag", "dagen"],
  hour:        ["uur", "uur"],   // Nederlands: onveranderlijk
  minute:      ["minuut", "minuten"],
};

export function nlTerm(key, count, opts = {}) {
  const forms = NL_TERMS[key];
  if (!forms) return `${count} ${key}`;
  return pluralize(count, forms[0], forms[1], opts);
}
